/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const PAYMENT_BASE_LINK = '/admin/payments'

export function getPaymentListLink () {
  return PAYMENT_BASE_LINK
}
